// extracted by mini-css-extract-plugin
module.exports = {"inlineAdWrapper":"Ux-z","microsoftAdsWrapper":"Vx-z","marketplaceRecosWrapper":"Wx-z"};